import React from "react";

const COLORS = {
  pending: { bg: "#dbeafe", color: "#2563eb" },
  sent: { bg: "#dcfce7", color: "#16a34a" },
  rejected: { bg: "#fee2e2", color: "#dc2626" },
};

export default function StatusBadge({ status }) {
  const style = COLORS[status] || COLORS.pending;
  return (
    <span className="badge" style={{ background: style.bg, color: style.color }}>
      {status}
    </span>
  );
}
